export type Competitiveness = 'Very Cheap' | 'Cheap' | 'Average' | 'Expensive' | 'Very Expensive'

const PRICING_SCALE = [
  ['Very Cheap', 0.5],
  ['Cheap', 1.5],
  ['Average', 2.5],
  ['Expensive', 4],
  ['Very Expensive', 100],
] as const

const PRICING_SCALE_AMOUNT_BASE_LOG = Math.log(1000)

export function getCompetitiveness(totalCost: number, amountUSD: number) {
  const costLogValue = Math.log(amountUSD) / PRICING_SCALE_AMOUNT_BASE_LOG
  for (const [key, range] of PRICING_SCALE) {
    const costBar = range / costLogValue
    if (totalCost <= costBar * 0.01 * amountUSD) {
      return key
    }
  }
  return 'Very Expensive' as const
}
